import { call, put, takeLatest } from "redux-saga/effects";
import PrecertificacionActions, {
  Types as PrecertificacionTypes,
} from "../../stores/precertificacion/Actions";
import PrecertificacionService from "../../services/precertificacion/PrecertificacionService";
import AseguradoService from "../../services/asegurado/AseguradoService";
import AuthService from "../../services/auth/AuthService";
import ResponseCode from "../../services/ResponseCode";
import {
  getMontoTotalReclamado,
  getMontoTotalArs,
  getMontoTotalAfiliado,
} from "../../containers/precertificacion/utils/PrecertificacionUtils";

import {
  getMontoTotalReclamado as getMontoTotalReclamadoAut,
  getMontoAutorizadoPrimera,
  getMontoAutorizadoHumano,
  getMontoAutorizadoTotal,
  getMontoDiferencia,
} from "../../containers/autorizacion/utils/AutorizacionUtils";

function* getPrecertificacion(request) {
  const { numeroSesion } = request.payload;

  yield put(PrecertificacionActions.getPrecertificacionLoading());

  const precertificacionResponse = yield call(
    PrecertificacionService.consultarPrecertificacion,
    AuthService.handleRequestSession(request.payload, numeroSesion)
  );

  if (
    !precertificacionResponse?.respuesta ||
    precertificacionResponse?.respuesta?.codigo ===
      ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      PrecertificacionActions.getPrecertificacionFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (
    precertificacionResponse?.respuesta?.mensaje !== ResponseCode.OK.message
  ) {
    yield put(
      PrecertificacionActions.getPrecertificacionFailure(
        precertificacionResponse?.respuesta
      )
    );
    return;
  }

  let dataPrecertificacion = precertificacionResponse?.data;

  const procedimientos = dataPrecertificacion?.precertificacion?.procedimientos;

  if (procedimientos?.length > 0) {
    dataPrecertificacion?.precertificacion?.procedimientos?.push({
      frecuencia: "Totales",
      montoARS: getMontoTotalArs(procedimientos),
      montoAfiliado: getMontoTotalAfiliado(procedimientos),
      montoReclamado: getMontoTotalReclamado(procedimientos),
    });
  }

  yield put(
    PrecertificacionActions.getPrecertificacionSuccess(dataPrecertificacion)
  );
}

function* confirmarPrecertificacion(request) {
  const { numeroSesion } = request.payload;

  yield put(PrecertificacionActions.confirmarPrecertificacionLoading());

  const afiliadoResponse = yield call(
    AseguradoService.consultarAsegurado,
    AuthService.handleRequestSession(request.payload, numeroSesion)
  );

  if (
    !afiliadoResponse?.respuesta ||
    afiliadoResponse?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      PrecertificacionActions.confirmarPrecertificacionFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (afiliadoResponse?.respuesta?.codigo !== ResponseCode.OK.code) {
    yield put(
      PrecertificacionActions.confirmarPrecertificacionFailure(
        afiliadoResponse?.respuesta
      )
    );
    return;
  }

  const confirmacionResponse = yield call(
    PrecertificacionService.confirmarPrecertificacion,
    AuthService.handleRequestSession(request.payload, numeroSesion)
  );

  if (
    !confirmacionResponse?.respuesta ||
    confirmacionResponse?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      PrecertificacionActions.confirmarPrecertificacionFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (
    confirmacionResponse?.respuesta?.mensaje?.toLocaleLowerCase() !==
    ResponseCode.OK.message?.toLocaleLowerCase()
  ) {
    yield put(
      PrecertificacionActions.confirmarPrecertificacionFailure(
        confirmacionResponse?.respuesta
      )
    );
    return;
  }

  yield put(
    PrecertificacionActions.confirmarPrecertificacionSuccess({
      autorizacion: confirmacionResponse?.data,
    })
  );
}

function* cancelarPrecertificacion(request) {
  const { numeroSesion } = request.payload;

  yield put(PrecertificacionActions.cancelarPrecertificacionLoading());

  const cancelacionResponse = yield call(
    PrecertificacionService.cancelarPrecertificacion,
    AuthService.handleRequestSession(request.payload, numeroSesion)
  );

  if (
    !cancelacionResponse?.respuesta ||
    cancelacionResponse?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      PrecertificacionActions.cancelarPrecertificacionFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (cancelacionResponse?.respuesta?.codigo !== 0) {
    yield put(
      PrecertificacionActions.cancelarPrecertificacionFailure(
        cancelacionResponse?.respuesta
      )
    );
    return;
  }

  yield put(
    PrecertificacionActions.cancelarPrecertificacionSuccess(cancelacionResponse)
  );
}

function* getAutorizacionMadreData(request) {
  yield put(PrecertificacionActions.getAutorizacionMadreDataLoading());

  const { numeroSesion } = request.payload;

  try {
    const autorizacionResponse = yield call(
      PrecertificacionService.getAutorizacionMadreData,
      AuthService.handleRequestSession(request.payload, numeroSesion)
    );

    if (
      !autorizacionResponse?.respuesta ||
      autorizacionResponse?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        PrecertificacionActions.getAutorizacionMadreDataFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    if (autorizacionResponse?.respuesta?.codigo !== ResponseCode.OK.code) {
      yield put(
        PrecertificacionActions.getAutorizacionMadreDataFailure(
          autorizacionResponse?.respuesta
        )
      );
      return;
    }

    let dataAutorizacion = autorizacionResponse?.data;
    const coberturas = dataAutorizacion?.autorizacionMadreCoberturaSalud;

    if (coberturas?.length > 0) {

      const totalDiferencia = getMontoDiferencia(coberturas);
      dataAutorizacion.autorizacionMadreCoberturaSalud.push({
        descripcion: "Totales",
        montoReclamado: getMontoTotalReclamadoAut(coberturas),
        montoAutorizacionPrimera: getMontoAutorizadoPrimera(coberturas),
        montoAutorizacionHumano: getMontoAutorizadoHumano(coberturas),
        montoAutorizado: getMontoAutorizadoTotal(coberturas),
        montoAsegurado: totalDiferencia,
      });
    }
    yield put(
      PrecertificacionActions.getAutorizacionMadreDataSuccess(
        autorizacionResponse?.data
      )
    );
  } catch (error) {
    yield put(
      PrecertificacionActions.getAutorizacionMadreDataFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: error.message || ResponseCode.SERVER_ERROR.message,
      })
    );
  }
}

const exportedArray = [
  takeLatest(PrecertificacionTypes.GET_PRECERTIFICACION, getPrecertificacion),
  takeLatest(
    PrecertificacionTypes.CONFIRMAR_PRECERTIFICACION,
    confirmarPrecertificacion
  ),
  takeLatest(
    PrecertificacionTypes.CANCELAR_PRECERTIFICACION,
    cancelarPrecertificacion
  ),
  takeLatest(
    PrecertificacionTypes.GET_AUTORIZACION_MADRE_DATA,
    getAutorizacionMadreData
  ),
];

export default exportedArray;
